import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ExternalAssociations from './components/ExternalAssociations.vue';
import UserLocation from './components/UserLocation.vue';
import StudentInfo from './components/StudentInfo.vue';
import StudentReferrals from './components/StudentReferrals.vue';
import UserGeneral from './components/UserGeneral.vue';
import MedicaidBilling from './components/MedicaidBilling.vue';
import ZoomClassroom from '@/components/Forms/User/ZoomLinkForm/ZoomClassroom.vue';
import { PersonStores } from '@/store';
import { computed } from 'vue';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { can, usePersonTypes, useTenant } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const profileStore = PersonStores.useUserProfileStore();
const $tenant = useTenant();

const medicaidEnabled = computed(() => $tenant.tenantSettingEnabled(TENANT_SETTINGS.MEDICAID_BILLING));

/**
 * computed property to load StudentInfo if the user is a student
 */
const isStudent = computed(() => usePersonTypes.isStudent(profileStore.person?.people_type?.acronym));

const isClinician = computed(() => usePersonTypes.isClinician(profileStore.person?.people_type?.acronym));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UserGeneral, { class: "page-content-half" }),
    _createVNode(UserLocation, { class: "page-content-half" }),
    (_unref(can)([_unref(PERMISSIONS).PEOPLE_INDEX_STUDENT_EXTERNAL_ASSOCIATIONS, _unref(PERMISSIONS).PEOPLE_INDEX_EXTERNAL_ASSOCIATIONS]))
      ? (_openBlock(), _createBlock(ExternalAssociations, {
          key: 0,
          class: "page-content-half"
        }))
      : _createCommentVNode("", true),
    (isClinician.value)
      ? (_openBlock(), _createBlock(ZoomClassroom, {
          key: 1,
          loading: _unref(profileStore).loading
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    (isClinician.value && medicaidEnabled.value)
      ? (_openBlock(), _createBlock(MedicaidBilling, {
          key: 2,
          loading: _unref(profileStore).loading,
          class: "page-content-full"
        }, null, 8, ["loading"]))
      : _createCommentVNode("", true),
    (isStudent.value && _unref(can)([_unref(PERMISSIONS).PEOPLE_INDEX_STUDENT]))
      ? (_openBlock(), _createBlock(StudentInfo, {
          key: 3,
          class: "page-content-half"
        }))
      : _createCommentVNode("", true),
    (isStudent.value && _unref(can)([_unref(PERMISSIONS).PEOPLE_INDEX_STUDENT]))
      ? (_openBlock(), _createBlock(StudentReferrals, { key: 4 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})